import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.58732 2.49556L2.80954 7.14799C2.29695 7.56074 2 8.176 2 8.82527V15.8272C2 17.0272 2.99492 18 4.22222 18H15.7778C17.0051 18 18 17.0272 18 15.8272V8.82527C18 8.176 17.703 7.56074 17.1905 7.14799L11.4127 2.49556C10.5921 1.83481 9.40789 1.83481 8.58732 2.49556ZM10.8477 3.16648L16.6254 7.81891C16.933 8.06656 17.1112 8.43571 17.1112 8.82528V15.8272C17.1112 16.5472 16.5142 17.1309 15.7778 17.1309H13.1112V12.1728L13.1064 12.03C13.0312 10.8965 12.0671 10 10.8889 10H9.11115L8.96504 10.0046C7.80585 10.0782 6.88893 11.0208 6.88893 12.1728V17.1309H4.22227C3.48589 17.1309 2.88893 16.5472 2.88893 15.8272V8.82528C2.88893 8.43571 3.0671 8.06656 3.37466 7.81891L9.15243 3.16648C9.64477 2.77003 10.3553 2.77003 10.8477 3.16648ZM7.77782 17.1309H12.2223V12.1728C12.2223 11.4952 11.6935 10.9383 11.0173 10.8751L10.8889 10.8691H9.11115C8.41809 10.8691 7.84853 11.3862 7.78392 12.0473L7.77782 12.1728V17.1309Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4107 3.5575L3.91073 8.79149C3.33407 9.25584 3 9.948 3 10.6784V18.5556C3 19.9056 4.11929 21 5.5 21H18.5C19.8807 21 21 19.9056 21 18.5556V10.6784C21 9.948 20.6659 9.25584 20.0893 8.79149L13.5893 3.5575C12.6661 2.81417 11.3339 2.81417 10.4107 3.5575ZM12.9536 4.31228L19.4536 9.54627C19.7996 9.82487 20 10.2402 20 10.6784V18.5556C20 19.3656 19.3284 20.0222 18.5 20.0222H15.5V14.4444L15.4947 14.2837C15.41 13.0086 14.3255 12 13 12H11L10.8356 12.0052C9.53154 12.088 8.5 13.1484 8.5 14.4444V20.0222H5.5C4.67157 20.0222 4 19.3656 4 18.5556V10.6784C4 10.2402 4.20044 9.82487 4.54644 9.54627L11.0464 4.31228C11.6003 3.86628 12.3997 3.86628 12.9536 4.31228ZM9.5 20.0222H14.5V14.4444C14.5 13.6821 13.9051 13.0556 13.1445 12.9845L13 12.9778H11C10.2203 12.9778 9.57955 13.5594 9.50687 14.3032L9.5 14.4444V20.0222Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'home');
export default IconComponent;
